import { DropdownItem } from '../types/ViewModel/DropdownItem';
import { DropdownGroup } from '../types/ViewModel/DropdownGroup';
import { DropdownItemFactory } from './DropdownItemFactory';
import { DropdownTypeEnum } from '../enums/dropdownTypeEnum';
import { DropdownGroupBM } from '../types/BusinessModel/DropdownGroupBM';

export class DropdownGroupFactory {
    private dropdownItemFactory = new DropdownItemFactory();

    constructor() {}

    private compareItemOrder(a: DropdownItem, b: DropdownItem, desc: boolean): number {
        let cmp: number = 0;
        if (a.itemOrder > b.itemOrder) {
            cmp = 1;
        } else if (b.itemOrder > a.itemOrder) {
            cmp = -1;
        }
        return desc ? cmp * -1 : cmp;
    }

    public newDropdownGroup(dropdownGroup: DropdownGroupBM, mandatory: boolean): DropdownGroup | null {
        let drdownGroup: DropdownGroup | null = null;
        if (dropdownGroup) {
            drdownGroup = this.newDropdownGroupItem(dropdownGroup, mandatory);
        }
        return drdownGroup;
    }

    private newDropdownGroupItem(item: DropdownGroupBM, mandatory: boolean): DropdownGroup {
        const dropdownItemArray: DropdownItem[] = [];
        item.dropdownItemList.map((eti) => {
            dropdownItemArray.push(this.dropdownItemFactory.newDropdownItem(eti));
        });
        const dropdownItemArraySorted = dropdownItemArray.sort((a, b) => this.compareItemOrder(a, b, false));
        //var dropdownItemArraySorted = dropdownItemArray.sort(di => di.itemOrder);
        return new DropdownGroup(
            item.dropdownGroupId,
            item.eventInputDropdownGroupId,
            item.description,
            item.multiple,
            item.dropdownType,
            dropdownItemArraySorted,
            mandatory,
            false,
            ''
        );
    }

    public createDropdownGroup(dropdownGroup: DropdownGroup) {
        if (dropdownGroup) {
            return new DropdownGroup(
                dropdownGroup.dropdownGroupId,
                dropdownGroup.eventInputDropdownGroupId,
                dropdownGroup.description,
                dropdownGroup.multiple,
                dropdownGroup.dropdownTypeId,
                this.dropdownItemFactory.createDropdownItemArray(dropdownGroup.dropdownItemArray),
                dropdownGroup.required,
                dropdownGroup.disabled,
                dropdownGroup.disabledItemName
            );
        }
        return null;
    }

    public newDropdownGroupFromCode(
        dropdownGroupId: number,
        eventInputDropdownGroupId: number,
        description: string,
        multiple: boolean,
        dropdownTypeId: DropdownTypeEnum,
        dropdownItemArray: DropdownItem[],
        required: boolean,
        disabled: boolean,
        disabledItemName: string
    ): DropdownGroup {
        const dpItemArray: DropdownItem[] = [];
        dropdownItemArray.map((eti) => {
            dpItemArray.push(this.dropdownItemFactory.createDropdownItem(eti));
        });
        const dpItemArraySorted = dropdownItemArray.sort((di) => di.itemOrder);
        return new DropdownGroup(
            dropdownGroupId,
            eventInputDropdownGroupId,
            description,
            multiple,
            dropdownTypeId,
            dpItemArraySorted,
            required,
            disabled,
            disabledItemName
        );
    }
}
